import styled from 'styled-components'

import { backgroundTypes, boxModelTypes, cssTypes } from '../types'
import { background, boxModel, css } from '../util'

/**
 * @namespace Header
 * @desc Primitive styled-component 💅
 * @return {Function} React component
 */
const Header = styled.header`
  ${background};
  ${boxModel};
  ${css};
`

/**
 * @name defaultProps
 * @memberof Header
 * @desc Primitive's default properties
 */
Header.defaultProps = {
  margin: [0],
  padding: [0],
  size: ['auto'],
}

/**
 * @name propTypes
 * @memberof Header
 * @desc Primitive's prop type definitions
 */
Header.propTypes = {
  ...backgroundTypes,
  ...boxModelTypes,
  ...cssTypes,
}

/** @component */
export default Header
